import type { SectionProps } from "../../../components/Questionnaire/Section";
import { isQuestion } from "../../../components/Questionnaire/Section/Question/types";
import type { QuestionProps } from "../../../components/Questionnaire/Section/Question/types";
import type { QuestionnaireState } from "../types";

export class QuestionFilters {
  private sections: SectionProps[];
  private currentSectionIndex: number;

  constructor({ sections, currentSectionIndex }: QuestionnaireState) {
    this.sections = sections;
    this.currentSectionIndex = currentSectionIndex;
  }

  /**
   * Get a list of question names in a given section index
   */
  inSectionIndex(sectionIndex: number): string[] {
    const sections = this.sections;
    const section = sections[sectionIndex];

    if (!section || section?.questions?.length === 0) {
      return [];
    }

    return section.questions.filter(isQuestion).map(question => question.name);
  }

  /**
   * Get a list of question names in the current section
   */
  inCurrentSection(): string[] {
    return this.inSectionIndex(this.currentSectionIndex);
  }

  /**
   * Find a question by its ID across all sections
   */
  getById(id: string): QuestionProps | undefined {
    for (const section of this.sections) {
      const question = section.questions
        .filter(isQuestion)
        .find(q => q.id === id);
      if (question) {
        return question;
      }
    }
    return undefined;
  }

  /**
   * Find a question by its name across all sections
   */
  getByName(name: string): QuestionProps | undefined {
    for (const section of this.sections) {
      const question = section.questions
        .filter(isQuestion)
        .find(q => q.name === name);
      if (question) {
        return question;
      }
    }
    return undefined;
  }
}
